import React from 'react';
import fetch from '../../core/fetch';

import Layout from '../../components/Layout';
import NotFound from '../not-found/NotFound';
import Page from './Page';

import { getContentPageQuery as query } from '../../lib/graphql';

async function action({ store, params }) {
    
    const resp = await fetch(`/graphql`, {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query,
            variables: { pageUrl: params.pageUrl }
        }),
        credentials: 'include',
    });

    const { data } = await resp.json();

    if (data?.getContentPage?.result) {
        return {
            title: data?.getContentPage?.result?.metaTitle,
            component: (
                <Layout><Page data={data.getContentPage.result} /></Layout>
            )
        }
    } else {
        return {
            title: "Not Found",
            component: <Layout><NotFound title="Not Found" /></Layout>,
            status: 404,
        };
    }
}

export default action;